// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/common.css'
import axios from 'axios'
import MetaInfo from 'vue-meta-info'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/elementUiChange.styl'
import './assets/css/base.styl'
import { showLoading, hideLoading } from './assets/js/loading'
import animated from 'animate.css'

import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
//import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage)

Vue.use(ElementUI)
Vue.use(animated)

Vue.use(MetaInfo)
Vue.prototype.$http = axios
Vue.config.productionTip = false

window.eventBus = new Vue()

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

import { MessageBox } from 'element-ui'

/* 请求拦截器（请求之前的操作） */
axios.interceptors.request.use(
  req => {
    //showLoading();
    return req
  },
  err => Promise.reject(err)
)

/* 请求之后的操作 */
axios.interceptors.response.use(
  res => {
    hideLoading()

    return res

    return Promise.reject(res)
  },
  err => {
    hideLoading()
    MessageBox.confirm('网络异常请稍后重试')
    return Promise.reject(err)
  }
)

Vue.prototype.comPath = 'https://www.yuemia.com/static/upload/'
Vue.prototype.shortComPath = 'https://www.yuemia.com/'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js